import { onUnmounted, Ref, ref, watch } from "@vue/composition-api";
import { differenceInMilliseconds, parseISO, toTimePassed } from "@/lib/time";

export default function useTimePassed(startTime: Ref<string>) {
  const timePassed = ref("");

  let interval: ReturnType<typeof setInterval>;

  watch(startTime, startTime => {
    interval && clearInterval(interval);
    if (!startTime) {
      timePassed.value = "";
      return;
    }
    const countDate = () => {
      timePassed.value = toTimePassed(Math.max(0, differenceInMilliseconds(new Date(), parseISO(startTime))));
    };
    countDate();
    interval = setInterval(countDate, 1000);
  });

  onUnmounted(() => interval && clearInterval(interval));

  return {
    timePassed,
  };
}
